import React, { memo } from 'react';
import css from './InstantBookingLandingPage.css';
import { ListingCard, NamedLink } from '../../components';
import isEqual from 'lodash/isEqual';
import Slider from 'react-slick';
import classNames from 'classnames';

export const SectionBrowseCar = memo(
  ({ intl, listings = [] }) => {
    const sliderConfig = {
      infinite: false,
      arrows: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      initialSlide: 0,
      centerPadding: '24px',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.25,
            slidesToScroll: 1,
            initialSlide: 0
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.25,
            slidesToScroll: 1,
            initialSlide: 0
          }
        }
      ]
    }
    return (
      <div className={css.sectionBrowseCar}>
        <div className={css.sectionBrowseCarDescription}>
          {intl.formatMessage({
            id: 'InstantBookingLandingPage.SectionBrowseCar.description'
          })}
        </div>
        <NamedLink name='SearchPage' className={classNames(css.button, css.browseCarBtn)} to={{
          search:
            `?pub_instantBooking=true&bounds=1.4708809,104.04157989999999,1.216611,103.60650989999999`,
        }}>
          Browse Instant booking cars
        </NamedLink>
        <div className={css.listings}>
          <Slider {...sliderConfig}>
            {listings.map(l => <div>
              <ListingCard listing={l} intl={intl} />
            </div>)}
          </Slider>
        </div>
      </div>
    )
  },
  (prev, next) => isEqual(prev.listings, next.listings)
)
